import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Loading from "../../../Common/Components/Loading";
import HorizentalCard from "./Components/HorizentalCard";
import { GetData, getOrderDetails } from "./Components/Services";
import Table from "./Components/Table";
import VerticalCard from "./Components/VerticalCard";
// Form Area Start
import { CostRender } from "../../../Common/Function/index";
import {
  athletesForm,
  classDetailsReserve,
  detailsReserveForm,
  detailsReserveFormDate,
  lastReserveForm,
  sansDetailsReserveForm,
} from "./Components/Forms";
import MemoIncomeIcon from "./Components/Icons/IncomeIcon";
import PercentageIcon from "./Components/Icons/PercentageIcon";
import LineChart from "./Components/LineChart";
import DataTable from "../../../Common/Components/DataTable";
import OrderList from "../../../Common/Components/OrlderList";
import { useNavigate } from "react-router-dom";
import { FaListOl } from "react-icons/fa";
import { AiOutlineShopping } from "react-icons/ai";
import { FiUsers } from "react-icons/fi";
import { BsCreditCard2Back } from "react-icons/bs";

function Index() {
  const initialState = {
    loading: true,
    data: null,
  };
  const [state, setstate] = useState(initialState);

  useEffect(() => {
    Handler();
  }, []);
  const navigate = useNavigate();
  const Handler = () => {
    setstate({ ...state, loading: true });
    GetData().then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | داشبورد مدیر مجموعه</title>
      </Helmet>

      <div className="">
        <div style={{ backgroundColor: "#F4F5FE" }}>
          <div>
            {state.loading ? (
              <Fragment>
                <Loading count={1} col={12} height={800} />
              </Fragment>
            ) : (
              <Fragment>
                <div className="row">
                  <VerticalCard
                    value={state.data.income_last_week}                    
                    iconComponent={<BsCreditCard2Back size={22} />}                    
                    title={"درآمد هفتگی"}
                  />
                  <VerticalCard
                    value={state.data.users_count}
                    iconComponent={<FiUsers size={22} />}                    
                    title={"تعداد کاربران"}
                  />
                  <VerticalCard
                    value={state.data.new_resrve_count}
                    iconComponent={<AiOutlineShopping size={22} />}
                    title={"سفارشات جدید"}
                  />
                  <VerticalCard
                    value={state.data.total_resreve_count}
                    iconComponent={<FaListOl size={22} />}
                    title={"مجموع تعداد رزورها"}
                  />
                </div>
                {
                  state.data.countuserproblem && state.data.countuserproblem != 0 ? (
                    <div className="row mb-2" onClick={() => { navigate('/Admin/UserProble') }} style={{ cursor: 'pointer' }} >
                      <div className="col-12 p-2 m-0 text-center" style={{ backgroundColor: '#E42A3F', color: 'white' }} >
                        تعداد {state.data.countuserproblem} کاربر درخواست تماس پشتبانی را داده اند برای مشاهده کلیک کید
                      </div>
                    </div>
                  ) : (
                    <></>
                  )
                }
                <div className="row">
                  <div className="col-12 p-0 m-0">
                    <OrderList short={5} />
                  </div>
                </div>

                <div className="row  my-4 ">
                  <LineChart line={state.data.chart} />
                  <div className="col-md-4 mt-5">
                    <HorizentalCard
                      value={state.data.day_income}
                      IconComponent={MemoIncomeIcon}
                      title={"درآمد روزانه"}
                    />
                    <HorizentalCard
                      value={state.data.Percentage_Two_Week}
                      IconComponent={PercentageIcon}
                      title={"درصد افزایش درآمد"}
                    />
                  </div>
                </div>
                <div className="row">
                  <DataTable
                    short={true}
                    heads={athletesForm}
                    data={state.data.last_users}
                    list={state.data.last_users}
                  />
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </Fragment >
  );
}

const ShowDetailsReserve = ({ id, data }) => {
  const [state, setstate] = useState({ loading: true, data: null });
  const handler = () => {
    setstate({ ...state, loading: true });
    getOrderDetails({
      order_id: id,
    }).then(response => {
      setstate({ loading: false, data: response });
    });
  };
  useEffect(() => {
    handler();
  }, []);

  const renderType = type => {
    switch (type) {
      case "shift":
      case "shiftwcount":
        return detailsReserveForm;
      case "shiftwdate":
      case "shiftwdatewcount":
        return detailsReserveFormDate;
      case "sans":
      case "sanswcount":
      case "sanswcountwgender":
      case "sanswgender":
        return sansDetailsReserveForm;
    }
  };
  if (data && data[0] && data[0].model_order == "joinclass") {
    return (
      <Fragment>
        {state.loading ? (
          <Loading count={1} col={12} height={200} />
        ) : (
          <div className="">
            <Table
              title={"جزییات سفارش"}
              textEmpty={"سفارشی ثبت نشده است"}
              col="col-12"
              form={classDetailsReserve}
              data={state && state.data && [state.data.product]}
              withOutShadow={false}
            />
          </div>
        )}
      </Fragment>
    );
  }

  return (
    <Fragment>
      {state.loading ? (
        <Loading count={1} col={12} height={200} />
      ) : (
        <div className="">
          <Table
            title={"جزییات سفارش"}
            textEmpty={"سفارشی ثبت نشده است"}
            col="col-12"
            form={renderType(
              data && data[0] && data[0].item_reserve_product.type
            )}
            data={state.data.product}
            withOutShadow={false}
          />
        </div>
      )}
    </Fragment>
  );
};
const ShowDetailsePayment = ({ id }) => {
  const [state, setstate] = useState({ loading: true, data: null });
  useEffect(() => {
    handler();
  }, []);

  const handler = () => {
    setstate({ ...state, loading: true });
    getOrderDetails({
      order_id: id,
    }).then(response => {
      setstate({ loading: false, data: response.peyment });
    });
  };

  const renderTypePayment = data => {
    switch (data) {
      case "gateway":
        return "آنلاین";
      case "wallet":
        return "کیف پول";
      case "manager":
        return "مدیر مجموعه";
      default:
        return data;
    }
  };

  return (
    <Fragment>
      <div className="">
        {state.loading ? (
          <Loading count={1} col={12} height={200} />
        ) : (
          <ul>
            <li className="d-flex border border-light p-2 m-2 justify-content-between">
              <span>مبلغ</span>
              <span>{CostRender.format(state.data.total_price)}</span>
            </li>
            <li className="d-flex border border-light p-2 m-2 justify-content-between">
              <span>نوع پرداخت</span>
              <span>
                {/* {renderTypepeyment(checkIsIn(state.peyment.type_peyment))} */}
                {state.data.type_payment
                  ? renderTypePayment(state.data.type_payment)
                  : "ثبت نشده است "}
              </span>
            </li>
            <li className="d-flex border border-light p-2 m-2 justify-content-between">
              <span>شماره ارجاع</span>
              <span>
                {state.data.ref_id ? state.data.ref_id : "ثبت نشده است "}
              </span>
            </li>

            <li className="d-flex border border-light p-2 m-2 justify-content-between">
              <span>شماره تراکنش</span>
              <span>
                {state.data.transid ? state.data.transid : "ثبت نشده است "}
              </span>
            </li>
            <li className="d-flex border border-light p-2 m-2 justify-content-between">
              <span>شماره پیگیری</span>
              <span>
                {state.data.trackingcode
                  ? state.data.trackingcode
                  : "ثبت نشده است "}
              </span>
            </li>
          </ul>
        )}
      </div>
    </Fragment>
  );
};
export default Index;
